import * as React from "react"

const Line3 = React.forwardRef((props, pathRef) => {
        return (
            <svg
                id={"line-3"}
                width={2}
                height={185}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    ref={pathRef}
                    className="line-3"
                    d="m.5.998 1 185"
                    strokeDashoffset={props.normalizedPosition }
                    strokeDasharray={props.pathLength}
                    strokeWidth={2}
                    stroke="#DEDDE2"
                />
            </svg>
        )
    }
)

export default Line3
